module.exports = __webpack_public_path__ + "img/previewer_icon.9090ed95.jpg";